import { ProblemAttachment } from '@/domain/entities/problem/problemAttachment'
import { ProblemRepository } from '@/domain/repositories/problem/ProblemRepository'

export class GetProblemAttachmentUseCase {
  constructor(private repository: ProblemRepository) {}

  async getProblemAttachment(problemId: string): Promise<ProblemAttachment> {
    try {
      const data = await this.repository.getProblemAttachment(problemId)
      return data
    } catch (error) {
      console.error(`Error in GetProblemAttachmentUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }
}
